import { render, staticRenderFns } from "./MKoreanCartNew.vue?vue&type=template&id=2c66acda&scoped=true"
import script from "./MKoreanCartNew.vue?vue&type=script&lang=js"
export * from "./MKoreanCartNew.vue?vue&type=script&lang=js"
import style0 from "./MKoreanCartNew.vue?vue&type=style&index=0&id=2c66acda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c66acda",
  null
  
)

export default component.exports